import { EventConfigurationKeys } from '@/enums/EventConfigurationKeys';

export const NAVIGATION_ITEMS = [
  {
    id: EventConfigurationKeys.Reception,
    route: '/reception',
  },
  {
    id: EventConfigurationKeys.Schedule,
    route: '/schedule',
  },
  {
    id: EventConfigurationKeys.MainStage,
    route: '/main-stage',
  },
  {
    id: EventConfigurationKeys.Sessions,
    route: '/sessions',
  },
  {
    id: EventConfigurationKeys.Posters,
    route: '/posters',
  },
  {
    id: EventConfigurationKeys.Expo,
    route: '/expo',
  },
  {
    id: EventConfigurationKeys.Lounge,
    route: '/lounge',
  },
  {
    id: EventConfigurationKeys.Helpdesk,
    route: '/help-desk',
  },
];

export type NavigationItemsType = typeof NAVIGATION_ITEMS;
